import { computed } from '@ember/object';
import ShBillableLineItem from './sh-billable-line-item';
import { belongsTo } from '@ember-data/model';

const ShInvoiceLineItem = ShBillableLineItem.extend({
  shInvoice: belongsTo('shInvoice', { async: false }),
  derivedFromProjectLineItem: belongsTo('projectLineItem', { async: false, inverse: 'relatedShInvoiceLineItems' }),
  derivedFromShInvoiceLineItem: belongsTo('shInvoiceLineItem', { async: false, inverse: 'relatedShInvoiceLineItem' }),
  relatedShInvoiceLineItem: belongsTo('shInvoiceLineItem', {async: false, inverse: 'derivedFromShInvoiceLineItem' }),

  adminDescription: computed('description', function () {
    return `Buyer ${this.get('description')}`;
  }),
});

export default ShInvoiceLineItem;
